// src/api.js
import axios from 'axios';

// 添加支出记录
export const addExpense = async (expense) => {
  const response = await axios.post('/api/addExpense', expense);
  return response.data;
};

// 获取支出记录 - 现在接收一个日期参数
export const getExpenses = async (date) => {
  const response = await axios.get('/api/getExpenses', {
    params: { date }
  });
  return response.data;
};

// 新增函数：按月获取支出记录
export const getExpensesByMonth = async (month, year) => {
  const response = await axios.get('/api/getExpensesByMonth', {
    params: { month, year }
  });
  return response.data;
};

// 新增函数：按年获取支出记录
export const getExpensesByYear = async (year) => {
  const response = await axios.get('/api/getExpensesByYear', {
    params: { year }
  });
  return response.data;
};

// 删除支出记录
export const deleteExpense = async (id) => {
  const response = await axios.delete('/api/deleteExpense', {
    data: { id }
  });
  return response.data;
};

// 更新支出记录
export const updateExpense = async (expense) => {
  const response = await axios.put('/api/updateExpense', expense);
  return response.data;
};
